var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"id":"iconamoon:arrow-up-2-light"}},[_c('path',{attrs:{"id":"Vector","d":"M18.6667 9.33366L12 16.0003L18.6667 22.667","stroke":"#1D1D1D","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }